<template>
  <div class="navigation-header">
    <nav class="navigation">
      <v-btn flat dark
       v-for="item in items"
        :key="item.text"
        :disabled="item.disabled"
        :to="item.path"
        v-if="item.name === 'Applications' && !isAdmin"
      >
        <v-icon left>{{item.icon}}</v-icon>
        <span class="text">{{item.text}}</span>
      </v-btn>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'NavigationHeader',
  data: () => ({
    items: [
      {
        name: 'Applications',
        text: 'Meus Requerimentos',
        icon: 'mdi-certificate',
        path: '/',
        disabled: false,
      },
    ],
  }),
  computed: {
    isAdmin() {
      return this.$router.currentRoute.meta.userAlias === 'admin';
    },
  },
};
</script>

<style scoped lang="scss">
</style>
